import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material/Button";
import { styled, alpha, darken, lighten } from "@mui/material/styles";

export const StyledLink = styled(Link)(({ theme: { palette, typography } }) => ({
  color: palette.grey["700"],
  fontSize: typography.pxToRem(15),
  textDecoration: "none",

  "&:hover": {
    textDecoration: "underline",
  },
}));

export const StyledAIButton = styled(Button)<ButtonProps>(({ theme }) => {
  const base = "#67cb7e";

  return {
    textTransform: "none",
    borderRadius: 12,
    padding: theme.spacing(1.25, 2),
    background: `linear-gradient(90deg, ${base} 0%, ${darken(base, 0.1)} 100%)`,
    color: theme.palette.common.white,
    boxShadow: `0 8px 20px ${alpha(base, 0.35)}`,
    transition: "transform 150ms ease, box-shadow 200ms ease, background 200ms ease",

    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: `0 12px 28px ${alpha(base, 0.5)}`,
      background: `linear-gradient(90deg, ${lighten(base, 0.06)} 0%, ${base} 100%)`,
    },

    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(1),
    },
  };
});
